"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.metaReducers = void 0;
var tslib_1 = require("tslib");
var metaState_1 = require("./metaState");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var setMeta = function (state, action) {
    var dashboard = action.payload.dashboard;
    state.persistedDashboard = dashboard;
    state.descriptor = dashboard
        ? {
            title: dashboard.title,
            description: dashboard.description,
            tags: dashboard.tags,
            shareStatus: dashboard.shareStatus,
            isUnderStrictControl: dashboard.isUnderStrictControl,
            isLocked: dashboard.isLocked,
        }
        : tslib_1.__assign({}, metaState_1.EmptyDashboardDescriptor);
};
var setDashboardTitle = function (state, action) {
    ts_invariant_1.default(state.descriptor);
    state.descriptor.title = action.payload;
};
exports.metaReducers = {
    setMeta: setMeta,
    setDashboardTitle: setDashboardTitle,
};
//# sourceMappingURL=metaReducers.js.map